import React from 'react';
import styled from 'styled-components/macro';

// const Parent = styled.div`
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-align: center;
//   -webkit-align-items: center;
//   -ms-flex-align: center;
//   align-items: center;
//   -webkit-box-pack: center;
//   -webkit-justify-content: center;
//   -ms-flex-pack: center;
//   justify-content: center;
//   min-height: ${p => p.minHeight};
//   height: ${p => p.height};
//   max-height: ${p => p.maxHeight};
//   flex-direction: column;
// `;

// const Child = styled.div`
//   -webkit-box-flex: 1;
//   -webkit-flex: 1;
//   -ms-flex: 1;
//   flex: 1;
//   min-width: ${p => p.minWidth};
//   width: ${p => p.width};
//   max-width: ${p => p.maxWidth};
// `;

// Internet Explorer 6-11
const isIE = /*@cc_on!@*/false || !!document.documentMode;

// Edge 20+
const isEdge = !isIE && !!window.StyleMedia;

const Parent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  position: ${isIE || isEdge ? '' : 'fixed'};
  min-height: ${p => p.minHeight || '100%'};
  top: 0;
`;

const Child = styled.div`
  display: block;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  margin-top: ${isIE || isEdge ? '200px' : ''};
  align-items: center;
  width: 100%;
  text-align: center;
`;

export default function Center(props) {
  const { minWidth, width, maxWidth, children, ...others } = props;
  let height = props.height || '100%';
  let maxHeight = props.maxHeight || '100vh';

  return (
    <Parent {...others} height={height} maxHeight={maxHeight}>
      <Child minWidth={minWidth} width={width} maxWidth={maxWidth}>
        {children}
      </Child>
    </Parent>
  );
}
